import { render, staticRenderFns } from "./GuideList.vue?vue&type=template&id=70232ac4&scoped=true"
import script from "./GuideList.vue?vue&type=script&lang=js"
export * from "./GuideList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70232ac4",
  null
  
)

export default component.exports